import { IToggleProvenancesModal } from '../../../actions/provenances/toggleProvenancesModal'
import { IProvenancesStore } from '../index'

export default function(
  store: IProvenancesStore,
  action: IToggleProvenancesModal,
): IProvenancesStore {
  return {
    ...store,
    modal: {
      ...store.modal,
      open: action.toggle,
    },
  }
}
